import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import CompletionToggle from 'components/CompletionToggle'
import { TaskListItemViewModel } from '../MilestonesViewModel'
import Member from 'iam/models/Member'
import styles from './TaskListItem.sass'
import Avatar from '../../../../../../../components/Avatar'

interface TaskListItemProps {
  item: TaskListItemViewModel
  isCardLayout?: boolean
}

const dateCompletedFormatter = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'long',
  hour: 'numeric',
  minute: '2-digit',
})

export default observer(function TaskListItem({
  item,
  isCardLayout,
}: TaskListItemProps) {
  const task = item.taskItem
  const suffix = isCardLayout ? 'new' : 'classic'

  return (
    <div
      className={cx(
        styles.item,
        item.isLastInList && styles.last,
        task.completed && styles.completed,
      )}
    >
      <div className={styles.itemInner}>
        <div className={styles.info}>
          <p className={styles.title} title={task.title}>
            {task.title}
          </p>
          {task.description && (
            <p className={styles.description} title={task.description}>
              {task.description}
            </p>
          )}
        </div>
        <div className={styles.actions}>
          {(item.canComplete || task.completed) && (
            <CompletionToggle
              completed={task.completed}
              onClick={item.toggleCompletion}
              size={32}
              readOnly={!item.canComplete}
              processing={item.toggleCompletion.pending}
              pulse={item.isNextIncompleteTask && item.canComplete}
              title={
                task.completed
                  ? `${
                      (task.completedBy || Member.none).displayName
                    } @ ${dateCompletedFormatter.format(task.completedAt)}`
                  : 'Click to mark this task completed'
              }
              dataTest={`milestone-task-completion-toggle-${task.id}-${suffix}`}
            >
              {task.completed && task.completedBy ? (
                <Avatar
                  greyscale
                  subject={task.completedBy}
                  size={32}
                  dataTest={`task-completed-${task.id}-${suffix}`}
                />
              ) : null}
            </CompletionToggle>
          )}
        </div>
      </div>
    </div>
  )
})
